module.exports = __webpack_public_path__ + "static/img/ban-8.308df61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-8.png
// module id = Byvh
// module chunks = 0